import React from 'react';
import { object, string } from 'prop-types';
import { Tooltip } from '@fiverr-private/fit';
import { POSITIONS } from '@fiverr-private/fit/src/components/Popover/constants';
import { I18nProvider } from '@fiverr-private/fiverr_context';
import { getBuyerTooltip } from '../../../utils/translation/pricingFactors/buyerTooltip';
import { getLabel } from '../../../utils/translation/pricingFactors/label';

const PricingFactorLabel = ({ name }, { general: { subCategoryId } }) => (
    <I18nProvider>
        {({ i18n }) => (
            <Tooltip content={getBuyerTooltip({ i18n, name, subCategoryId })}
                position={POSITIONS.TOP}>
                {getLabel({ i18n, name, subCategoryId })}
            </Tooltip>
        )}
    </I18nProvider>
);

PricingFactorLabel.propTypes = {
    name: string.isRequired
};

PricingFactorLabel.contextTypes = {
    general: object
};

export default PricingFactorLabel;
